import { db } from "../../../firebase";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { storage } from "../../../firebase";
import { getDownloadURL, uploadBytesResumable, ref } from "firebase/storage";

function EditBrandItem(props) {
  const [brand, setBrand] = useState([]);
  const [isSubmit, setIsSubmit] = useState(false);
  const [progress, setProgress] = useState(0);
  const [file, setFile] = useState(null);
  const [imageUrl, setImageUrl] = useState("");

  // states for each form field
  const [brandName, setBrandName] = useState(null);
  const [description, setDescription] = useState(null);

  useEffect(() => {
    const getdata = async () => {
      const brandData = doc(db, "brands", props.match.params.id);
      const data = await getDoc(brandData);
      const result = data.data();
      setBrand(result);
      setBrandName(result.brandName);
      setDescription(result.description);
      setImageUrl(result.brandImage);
    };
    getdata();
  }, [props.match.params.id]);

  // Handle form submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    const brandsDoc = doc(db, "brands", props.match.params.id);
    const newBrand = {
      brandName: brandName,
      description: description,
      brandImage: imageUrl,
    };

    await updateDoc(brandsDoc, newBrand);
    setIsSubmit(true);

    e.target.reset();
  };

  //Handle Field Changes

  const brandNameChangeHandler = (e) => {
    setBrandName(e.target.value);
  };
  const descriptionChangeHandler = (e) => {
    setDescription(e.target.value);
  };

  // handle modal actions;

  const addNew = () => {
    setIsSubmit(false);
  };

  const returnToInventory = () => {
    setIsSubmit(false);
  };

  // Handle Image Uploads

  const uploadFile = (file) => {
    // if file doesnt exist return
    if (!file) return;
    // if file does exist;

    const storageRef = ref(
      storage,
      `/brand-images/${file.lastModified}${file.name}`
    );
    let uploadTask = uploadBytesResumable(storageRef, file);
    return uploadTask.on(
      "state_changed",
      (snapshot) => {
        const prog = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setProgress(prog);
      },
      (err) => console.log(err),
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((url) => {
          setImageUrl(url);
        });
      }
    );
  };

  const handleChange = (e) => {
    setFile(e.target.files);
  };

  const handleUpload = async () => {
    setImageUrl("");

    uploadFile(file[0]);
  };

  return (
    <div className="new-product">
      {isSubmit && (
        <div className="modal">
          <div className="modal__container">
            <h3>New Brand Added</h3>
            <button type="button" onClick={addNew}>
              Continue Editing
            </button>
            <Link to="/bj-admin/brands">
              <button type="button" onClick={returnToInventory}>
                Return To Brand List
              </button>
            </Link>
          </div>
        </div>
      )}
      <h1 className="new-product__title">Edit {brand.brandName}</h1>
      <Link to="/bj-admin/brands">
        <button type="button" onClick={returnToInventory}>
          Return To Brands
        </button>
      </Link>
      <form className="new-product__form" onSubmit={handleSubmit}>
        <label htmlFor="barndName">Brand Name</label>
        <input
          type="text"
          name="brandName"
          required
          value={brandName}
          onChange={brandNameChangeHandler}
        />
        <label htmlFor="description">Description</label>
        <textarea
          name="description"
          required
          value={description}
          onChange={descriptionChangeHandler}
        />

        <div>
          <progress value={progress} max="100" />
          <br />
          <br />
          <input
            type="file"
            name="images"
            onChange={handleChange}
            accept="image/*"
          />
          <button onClick={handleUpload} type="button">
            Upload
          </button>
          <br />
          <br />
          {
            <div className="image-container">
              <img
                className="image-container__image"
                style={{ width: "500px" }}
                src={imageUrl || "http://via.placeholder.com/300"}
                alt="firebase-prev"
              />
            </div>
          }
        </div>

        <button>Submit Edit</button>
      </form>
    </div>
  );
}

export default EditBrandItem;
